import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { withFirebase } from 'services/firebase';
import { withRouter } from 'react-router-dom';

import * as ROUTES from 'config/constants/routes';

import { saveUser, saveCompany } from 'redux/auth';

const withAuthorization = Component => {
  class WithAuthorization extends React.Component {
    state = { user: null }

    componentDidMount() {
      const { firebase, history, saveUser, saveCompany } = this.props;

      this.listener = firebase.auth.onAuthStateChanged(
        async user => {
          if (!user) history.push(ROUTES.LOGIN);
          const userRef = await firebase.user;
          const userData = await firebase.userData()

          this.setState({ user });
          firebase.userBindRedux(userRef, saveUser);
          firebase.companyBindRedux(userData.companyId, saveCompany);
        },
      );
    }

    componentWillUnmount() {
      this.listener();
    }

    render() {
      if (!this.state.user) return null;

      return (
        <Component {...this.props} user={this.state.user} />
      );
    }
  }

  return compose(
    withRouter,
    withFirebase,
    connect(null, { saveUser, saveCompany })
  )(WithAuthorization);
};

export default withAuthorization;
